import useIsInExperiment from '~/hooks/common/experiments/useIsInExperiment';

export default function useIsInServiceLandingExperiment() {
  return useIsInExperiment(
    'car-merch-ui-dealership-service-landing',
    'treatment'
  );
}
